<template>
  <div>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <day-view v-for="d in days" v-bind:key="d.index" v-bind:dayItem="d"></day-view>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
  import DayView from "./DayView.vue";

  export default {
    components: {
      DayView
    },
    data() {
      return {};
    },
    computed: {
      ...mapGetters({
        loading: "getLoading",
        days: "getDays"
      })
    },
    methods: {},
    created: function () {
      this.$store.dispatch("getAllClasses");
    }
  };
</script>

<style>
</style>